<template>
  <div class="col-xs-12 variationsBlock productBgBlock">
    <div class="variation-image-container">
      <div v-for="variationEntry in getVariationEntriesOfThisGroupFromVariationGroupData"
           :key="variationEntry.variationId"
           class="variation-image"
      >
        <img
          :src="`/files/product_variations/${variationEntry.variationDisplayValue}`"
          :alt="variationEntry.variationName"
          v-on:click="navigateToProduct(variationEntry.variationId)"
          class="img-fluid"
          width="100"
          height="100"
        >
        <span class="variation-image-text" v-html="getVariationImageStatus(defaultValue, variationEntry)"></span>
      </div>

    </div>
  </div>
</template>

<script>

import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationImageSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      selected: null
    }
  },
  methods: {
    getVariationOutOfStock (variation) {
      return variation.stock <= 0
    },
    getVariationImageStatus (defaultValue, variation) {
      if (defaultValue === variation.variationName) {
        return '<i class="lni lni-checkmark variation-image-current_product"></i>'
      } else if (this.getVariationOutOfStock(variation)) {
        return '<span class="variation-image-out_of_stock">Out of Stock</span>'
      }
    }
  }
}
</script>
